import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { ModuleType, ClinicModule } from '@/hooks/useModules'

// Using ClinicModule interface from useModules

// Interface for updating modules
export interface UpdateModules {
  modules: Record<string, boolean>
}

export const clinicModuleService = {
  /**
   * 取得診所模組列表
   * @param clinicId 診所ID
   * @param token 認證Token
   * @returns 模組列表
   */
  getClinicModules: async (clinicId: number, token: string) => {
    try {
      const response = await apiClient.get<{ success: boolean; data: ClinicModule[] }>(
        `/api/clinics/${clinicId}/modules`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
        data: [],
      }
    }
  },

  /**
   * 更新診所模組狀態
   * @param clinicId 診所ID
   * @param modules 模組狀態
   * @param token 認證Token
   * @returns 更新結果
   */
  updateClinicModules: async (
    clinicId: number,
    modules: Record<string, boolean>,
    token: string,
  ) => {
    try {
      const response = await apiClient.put<{ success: boolean }>(
        `/api/clinics/${clinicId}/modules`,
        { modules },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  /**
   * 取得模組名稱
   * @param moduleType 模組類型
   * @returns 模組名稱
   */
  getModuleName: (moduleType: string): string => {
    const moduleTypeNames: Record<string, string> = {
      [ModuleType.QUEUE_SYSTEM]: '叫號系統',
      [ModuleType.APPOINTMENT_SYSTEM]: '預約系統',
      [ModuleType.THIRD_PARTY_QUEUE]: '第三方叫號',
    }
    return moduleTypeNames[moduleType] || moduleType
  },
}
